import { ControllerConnectedMessage, ControllerDisconnectedMessage, ControllerMovedMessage, ControllerTrackingChangedMessage, ControllerVisibilityMessage, MouseConnectedMessage, MouseDisconnectedMessage } from "../../../messages/controller/ControllerMessages";
import { ControllerHand, InputDeviceType } from "flavr-common";
const DEFAULT_MOUSE_RAY_ORIGIN = [0, 0, 0];
const DEFAULT_MOUSE_RAY_DIRECTION = [0, 0, -1];
export class PeerControllerMessageHandler {
    constructor(connection, peerMgr) {
        this.peerMgr = peerMgr;
        this.handleControllerConnectedMessage = (msg) => {
            this.peerMgr.addLocalController(msg.uid, msg.controllerType, msg.hand, msg.rayOrigin, msg.rayDirection, msg.hasTrackedHand);
        };
        this.handleControllerDisconnectedMessage = (msg) => {
            this.peerMgr.removeLocalController(msg.uid);
        };
        this.handleMouseConnectedMessage = (msg) => {
            this.peerMgr.addLocalController(msg.uid, InputDeviceType.Mouse, ControllerHand.RightHand, DEFAULT_MOUSE_RAY_ORIGIN, DEFAULT_MOUSE_RAY_DIRECTION);
        };
        this.handleMouseDisconnectedMessage = (msg) => {
            this.peerMgr.removeLocalController(msg.uid);
        };
        this.handleControllerMovedMessage = (msg) => {
            this.peerMgr.onMoveController(msg);
        };
        this.handleControllerTrackingChangedMessage = (msg) => {
            this.peerMgr.updateLocalControllerTracking(msg.uid, msg.hasTrackedHand);
        };
        /**
         * Mirrors the local ControllerVisibilityMessage onto all active peer controller views so
         * that remote-peer controller meshes honour the same show/hide setting as local ones.
         */
        this.handleControllerVisibilityMessage = (msg) => {
            this.peerMgr.isShowingVrController = msg.visible;
            for (const controller of this.peerMgr.peersControllers.values()) {
                if (controller.view === undefined)
                    continue;
                // Only show the controller mesh when it is not currently suppressed by hand-tracking.
                const showVrController = msg.visible && !controller.hasTrackedHand;
                controller.view.showVrController(showVrController, this.peerMgr.pendingBusMessages);
            }
        };
        connection.subscribeByType(ControllerConnectedMessage, this.handleControllerConnectedMessage);
        connection.subscribeByType(ControllerDisconnectedMessage, this.handleControllerDisconnectedMessage);
        connection.subscribeByType(MouseConnectedMessage, this.handleMouseConnectedMessage);
        connection.subscribeByType(MouseDisconnectedMessage, this.handleMouseDisconnectedMessage);
        connection.subscribeByType(ControllerMovedMessage, this.handleControllerMovedMessage);
        connection.subscribeByType(ControllerTrackingChangedMessage, this.handleControllerTrackingChangedMessage);
        connection.subscribeByType(ControllerVisibilityMessage, this.handleControllerVisibilityMessage);
    }
}
